export default __webpack_public_path__ + "static/caramel-eyelet-banner-desktop-a1dab6f03c953c36cdf27c3f59393e1e.webp";